import PropTypes from 'prop-types';
import React from 'react';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { CHANNEL_COLORS } from './aggregation_page_colors';
import {
  VIDEO_SERIES_PAGE_TYPE,
  WATCH_HOME_IDS
} from '../../constants';
import classNames from 'classnames';
import {find, get} from 'lodash';
import { onHomepage } from '../../utils/dom';

const onWatchPage = (pageId) =>
  WATCH_HOME_IDS.includes(pageId);


const aboutLabel = (page_type) => (
  <div className="about-static">
    {
      page_type === VIDEO_SERIES_PAGE_TYPE
        ? (
          <RosettaFormattedMessage parentFilename={__filename}
            id="series"
            description="About"
            defaultMessage="About"
          />
        )
        : (
          <RosettaFormattedMessage parentFilename={__filename}
            id="about"
            description="About"
            defaultMessage="About"
          />
        )
    }
  </div>
);

const missionLabel = () => (
  <div className="about-static">
    <RosettaFormattedMessage parentFilename={__filename}
      id="mission"
      description="Our Mission"
      defaultMessage="Our Mission"
    />
  </div>
);

const aboutStyle = (pageId, location, edition_data) => {
  const channelColors = find(CHANNEL_COLORS, { 'id': pageId });

  if (!channelColors || onHomepage(location, edition_data)) {
    return {};
  }

  return {
    backgroundColor: get(channelColors, 'colors[0]', ''),
    color: get(channelColors, 'text_color', '')
  };
};

export const About = (
  { about, pageId, title, page_type },
  { location, edition_data }
) => (
  <aside style={aboutStyle(pageId, location, edition_data)}
    className={classNames('about-section', {
      'homepage': onHomepage(location, edition_data)
    })}
  >
    <div className="about-content">
      { title && !onWatchPage(pageId) && <div className="about-title">{title}</div> }
      { onHomepage(location, edition_data) ? missionLabel() : aboutLabel(page_type) }
      { about }
    </div>
  </aside>
);

About.propTypes = {
  about: PropTypes.string.isRequired,
  pageId: PropTypes.number,
  title: PropTypes.string,
  page_type: PropTypes.string
};

About.contextTypes = {
  location: PropTypes.object,
  edition_data: PropTypes.object
};

const decorator = withViewportScrollTracking({
  eventParams: () => [
    'Scroll Depth',
    'Scroll',
    'Reached About'
  ]
});

export default decorator(About);
